import { render } from "./archive.vue?vue&type=template&id=04819e3a"
import script from "./archive.vue?vue&type=script&lang=js"
export * from "./archive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__